import { render, staticRenderFns } from "./ConsoleTour.vue?vue&type=template&id=72423c60&scoped=true&"
import script from "./ConsoleTour.vue?vue&type=script&lang=js&"
export * from "./ConsoleTour.vue?vue&type=script&lang=js&"
import style0 from "./ConsoleTour.vue?vue&type=style&index=0&id=72423c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72423c60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VTab,
  VTabItem,
  VTabs,
})
